module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/59d4e02dc5707465a6fa6e1d5d5338ab.png";